/** @file clipStateOf: the pose ClipState of a clip clock (loops from clipFrame, blend weight from pose). */
import type { ClipState } from '@zilo/pose3d-pose/contract';
import { blendWeight } from '@zilo/pose3d-pose/blend/blendWeight';
import { clipFrame } from '@zilo/pose3d-pose/time/clipFrame';
import type { ClipClock } from '@zilo/pose3d-runtime-babylon/clip/clipClockTypes';

/** `{ clip, time, loops: clipFrame(...).wraps }` plus `blendFrom` with `blendWeight(elapsed, duration)` while blending. */
export function clipStateOf(clock: ClipClock): ClipState {
  const loops = clipFrame(clock.clip, clock.time, { frame: 0, wraps: 0, elapsed: 0, ticks: 0 }).wraps;
  const b = clock.blendFrom;
  return b === null
    ? { clip: clock.clip, time: clock.time, loops }
    : { clip: clock.clip, time: clock.time, loops, blendFrom: { clip: b.clip, time: b.time, weight: blendWeight(b.elapsed, b.duration) } };
}
